import { render } from "./newIndex.vue?vue&type=template&id=3c82d69b&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"

import "./newIndex.vue?vue&type=style&index=0&id=3c82d69b&lang=scss&scoped=true"
import "./newIndex.vue?vue&type=style&index=1&id=3c82d69b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c82d69b"],['__file',"src/components/BaseUi/ProductDetailsCards/newIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c82d69b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c82d69b', __exports__)) {
    api.reload('3c82d69b', __exports__)
  }
  
  module.hot.accept("./newIndex.vue?vue&type=template&id=3c82d69b&scoped=true", () => {
    api.rerender('3c82d69b', render)
  })

}


export default __exports__